import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './PolicyTable.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';

interface IPolicyTableProps extends MappedComponentProperties {
    tableBorderEnabled?: boolean;
    gridLayout?: string;
    policyTableItems?: IPolicyTableItem[];
}

interface IPolicyTableItem {
    fullWidth?: boolean;
    content?: string;
    contentColor?: string;
    backgroundColor?: string;
    cellType?: string;
}

export const PolicyTableEditConfig = {
    emptyLabel: 'PolicyTable',
    isEmpty: (props: PropsWithChildren<IPolicyTableProps>) => {
        return !props || !props.policyTableItems || !props.policyTableItems.length;
    },
};

const PolicyTable = (props: PropsWithChildren<IPolicyTableProps>): JSX.Element => {
    const groupedPolicyTableItems:IPolicyTableItem[][] = [];
    const borderWidth = (props.tableBorderEnabled ? '2px' : 0);
    let columns;

    if (props.gridLayout) {
        columns = props.gridLayout?.split('fr').length - 1;
    }

    if (props.policyTableItems && columns) {
        for (let i = 0; i < props.policyTableItems.length; i += columns) {
            groupedPolicyTableItems.push(props.policyTableItems.slice(i, i + columns));
        }
    }

    return (
        <div id='policy-table' className={'PolicyTableComponent'}>
            {props.policyTableItems && (
                <table
                    data-testid={'policy-grid'}
                    className={'policy-grid'}
                    style={{
                        gridTemplateColumns: props.gridLayout,
                        borderWidth: borderWidth,
                        borderColor: '#231F20',
                    }}
                >
                    <tbody style={{ display: 'contents' }}>
                        {groupedPolicyTableItems.map((row: IPolicyTableItem[], index) => {
                            return (
                                <tr key={index} style={{ display: 'contents' }}>
                                    {row.map((item, i) => {
                                        const color = item.contentColor ? item.contentColor.substring(1) : '222222';
                                        const selector = `policy-grid-item-content-${color}`;
                                        const Tag = item.cellType === 'dataCell' ? 'td' : 'th';

                                        return (
                                            <Tag
                                                key={`policy-item-${i}`}
                                                data-testid={`policy-grid-item${(item.fullWidth) ? '-fw' : ''}`}
                                                className={`policy-grid-item${(item.fullWidth) ? '-fw' : ''}`}
                                                style={{
                                                    borderWidth: borderWidth,
                                                    borderColor: '#231F20',
                                                    backgroundColor: item.backgroundColor,
                                                }}
                                            >
                                                <style>
                                                    {
                                                        `
                                                        .${selector} * {
                                                            color: #${color}
                                                        }
                                                    `
                                                    }
                                                </style>
                                                {item.content && (
                                                    <div className={selector} style={{
                                                        gridColumn: (i + 1),
                                                        color: item.contentColor,
                                                    }}>
                                                        {transformHTMLParserLinks(item.content)}
                                                    </div>
                                                )}
                                            </Tag>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default PolicyTable;
